import { render, staticRenderFns } from "./doc.vue?vue&type=template&id=07bc194a&scoped=true&"
import script from "./doc.vue?vue&type=script&lang=js&"
export * from "./doc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc194a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VCardTitle,
  VContainer,
})
